import getSafe from "../../../hooks/helpers"
import flagIconGrey from '../../../../assets/icons/flag-white.png';
import flagIconRed from '../../../../assets/icons/flag-red.png';
import { getSupplierDoc } from "../../../utils/supplier";

export const Flag = ({
    participatingSuppliersMap,
    supplierId
}) => {
    const supplierDoc = getSupplierDoc(participatingSuppliersMap, supplierId);
    const isThumbApplied = supplierDoc && supplierDoc.flag === 'red_flag';
    const surrogateTitle = 'Flagged Supplier';
    const iconSrc = isThumbApplied ? flagIconRed : flagIconGrey;
    return (
        <img
            src={iconSrc}
            title={surrogateTitle}
        />
    );
}
